/**
 * Where an admin checks the addresses that bounced (ALU-287): the notice's
 * "Revisar invitaciones", the pause email and the classic banner. In
 * Encuentro, Miembros' one list on Invitación enviada filtered to "No
 * contactable" (ALU-294), where each row says why (rebotó, spam, pidió no
 * recibir más); in the classic admin, Miembros › Invitaciones, where each
 * bounced invitation says so.
 */
export function bouncedInvitationsPath(orgSlug: string, ui: 'classic' | 'encuentro'): string {
  return ui === 'encuentro'
    ? `/in/${orgSlug}/admin/members?state=invited&mark=unreachable`
    : `/in/${orgSlug}/admin/members?tab=invitations`
}
